<h1 [cypress]="'page_title'" class="nes-mb-3" style="font-size: 32px; font-weight: bold;">
  {{ "COMPOSE.PRODUCTS_OVERVIEW.PAGE_HEADER.TITLE" | translate }}
</h1>
<ng-container *ngIf="!isSubsequentCard">
  <nes-highlight-box class="nes-mb-6" type="info">
    <p class="nes-text-default" style="font-size: 14px;">
      <strong>{{ "COMPOSE.PRODUCTS_OVERVIEW.HIGHLIGHT_BOX.BOLD_TEXT" | translate }}</strong>
      {{ "COMPOSE.PRODUCTS_OVERVIEW.HIGHLIGHT_BOX.TEXT" | translate }}

      <nes-link (nesOnClick)="mijnNsZakelijkClick.emit()">{{
        "COMPOSE.PRODUCTS_OVERVIEW.HIGHLIGHT_BOX.LINK_TEXT" | translate
      }}</nes-link>
    </p>
  </nes-highlight-box>
  <p class="nes-mb-5 subtext-spacing">
    {{ "COMPOSE.PRODUCTS_OVERVIEW.PAGE_HEADER.SUBTEXT" | translate }}
  </p>
  <div class="checklist">
    <nes-text-list
      list-type="unordered"
      size="base"
      color="text-body"
    >
      <nes-text-list-item
        *ngFor="
          let item of 'COMPOSE.PRODUCTS_OVERVIEW.PAGE_HEADER.CHECKLIST'
            | translate
        "
        ><span [innerHTML]="item"></span
      ></nes-text-list-item>
    </nes-text-list>
  </div>
</ng-container>
